// Main websocket
let ws = null

// Websocket url
const url = (document.location.protocol !== 'https:' ? 'ws://dev.cooloc.local:4000' : 'wss://' + document.location.host) + '/api/chat'

/** Listen for websocket events */
export const open = (eventBus) => {
  console.log('Websocket connected to ' + url)
  if (!('WebSocket' in window)) return console.warn('Websocket not handled by browser')
  //TODO: google analytics to know if we need to setup long pooling

  // Close old one
  if (ws) {
    ws.onclose = ws.onmessage = null
    ws.close()
  }

  // Start websocket
  ws = new WebSocket(url)

  // Message received
  ws.onmessage = ev => {
    let data = ev.data
    const action = data[0]

    // Message
    if (action === '{') {
      data = JSON.parse(data)
      if (data) eventBus.$emit('chat:message', data)
    } else if (action === '+') {
      eventBus.$emit('chat:online', data.substr(1))
    } else if (action === '-') {
      eventBus.$emit('chat:offline', data.substr(1))
    }
  }

  // Auto reconnect
  ws.onclose = () => {
    setTimeout(() => {
      ws.onclose = ws.onmessage = null
      open(eventBus)
    }, 1000)
  }

  // Idle detection
  uninstallIdleDetection()
  installIdleDetection(eventBus)
}

/** Stop listening for websocket events */
export const close = () => {
  console.log('Websocket close')
  if (ws) {
    ws.onclose = ws.onmessage = null
    ws.close()
    uninstallIdleDetection()
  }
}

/** Returns true if the websocket should be open */
export const isOpen = () => {
  return !!ws
}

// Idle status
let is_idle = true

// Idle timer
let idle_timer = null

// Set the name of the hidden property and the change event for visibility
let hidden, visibilityChange
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden'
  visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden'
  visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden'
  visibilityChange = 'webkitvisibilitychange'
}

// To uninstall idle detection
var uninstallIdleDetection = () => {}

/** Set status as idle when inactive for 10 minutes */
const installIdleDetection = (eventBus) => {
  idle_timer = null
  is_idle = false

  // Change idle status
  const setIdle = state => {
    if (is_idle === state) {
      return
    }

    is_idle = state

    if (ws) {
      send('s' + (state ? '0' : '1'))
    }

    eventBus.$emit('chat:idle', state)
  }

  const send = (message, callback) => {
    waitForConnection(function () {
      ws.send(message)
      if (typeof callback !== 'undefined') {
        callback()
      }
    }, 1000)
  }

  const waitForConnection = (callback, interval) => {
    if (ws.readyState === 1) {
      callback()
    } else {
      setTimeout(function () {
        new waitForConnection(callback, interval)
      }, interval)
    }
  }

  // Handle page visibility change
  const handleVisibilityChange = () => setIdle(document[hidden])

  // Called when user interacts
  const resetTimer = () => {
    clearTimeout(idle_timer)
    idle_timer = setTimeout(() => setIdle(true), 5 * 60 * 1000)

    // Re-active
    setIdle(false)
  }

  document.addEventListener('mousemove', resetTimer, true)
  document.addEventListener('keydown', resetTimer, true)
  window.addEventListener('scroll', resetTimer, true)
  window.addEventListener('touchstart', resetTimer, true)
  document.addEventListener(visibilityChange, handleVisibilityChange, false)
  resetTimer()

  uninstallIdleDetection = () => {
    clearTimeout(idle_timer)
    document.removeEventListener('mousemove', resetTimer, true)
    document.removeEventListener('keydown', resetTimer, true)
    window.removeEventListener('scroll', resetTimer, true)
    window.removeEventListener('touchstart', resetTimer, true)
    document.removeEventListener(visibilityChange, handleVisibilityChange, false)
  }
}
